import React from 'react';
import Main from './pages/Main';
import { Route, Routes } from 'react-router';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Register from 'pages/Register';
const Router = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Main />
          </ProtectedRoute>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
    </Routes>
  );
};
export default Router;
